<script lang="ts">
  // A service's mark on its brand colour, at the top of its Sync page.
  import { SERVICES, type SyncService } from './services'

  export let service: SyncService
  export let size: 'sm' | 'lg' = 'sm'

  $: info = SERVICES[service]
  $: box = size === 'lg' ? 'h-12 w-12 rounded-xl text-2xl' : 'h-10 w-10 rounded-lg text-xl'
  $: inner = size === 'lg' ? 'h-7 w-7' : 'h-6 w-6'
</script>

<span class="flex shrink-0 items-center justify-center text-white {box}" style="background-color: {info.color}" aria-hidden="true">
  {#if info.icon}
    <i class={info.icon} />
  {:else if info.mask}
    <span class="block bg-white {inner}" style="-webkit-mask: url('{info.mask}') center / contain no-repeat; mask: url('{info.mask}') center / contain no-repeat;" />
  {/if}
</span>
